<template>
    <div class="tuoshou">
        <div ref="height_top" v-bind:style="{ height: tableHeight + 'px' }" style="overflow: auto;">
            <el-row>
                <el-col :span="24">
                    <div class="container">
                        <!-- 标题 -->
                        <h1 class="header-title">脱手网——让滞纳元器件“流转”新生，共赢绿色工业未来！</h1>
                        <!-- 核心内容区块 -->
                        <div class="content-block">
                            <p>面对仓库里积压的电气元器件，您是否首先感到的是“一团乱麻”？型号繁杂、数量不清、价值不明……管理失控，才是滞纳问题的根源。 盲目寻找买家，往往事倍功半。</p>
                            <p>脱手网的第一步，是先为您当好“库存管家”。我们深知，若无法清晰掌控资产，一切流通都无从谈起。因此，我们首先为您提供强大的智能库存管理软件。它如同为您的滞纳品库装上“智慧大脑”，实现一键录入、智能分类、价值评估与动态盘点。让您从此对滞纳资产总量、库龄结构、资金占用情况了如指掌，变“糊涂账”为“明白账”，为后续盘活奠定坚实基础。</p>
                            <p>管理清晰之后，关键一步在于“如何变现”。 传统的困境在于信息孤岛——您有的，买家找不到；买家要的，您不知道。脱手网的第二步，就是为您彻底打破这堵墙。</p>
                            <p>
                                通过我们的PC端与APP双端平台，您将不再是一座孤岛。管理好的库存，可一键发布至覆盖全国的供需网络。系统通过智能匹配，精准链接海量潜在买家，极大提升交易效率。这不仅是一个交易工具，更是一个强大的流通生态，让“管理”的成果高效转化为“流通”的收益。
                            </p>
                            <p>从“管好”的根基，到“卖好”的通途，脱手网提供的是始于管理、终于变现的完整解决方案。 我们不仅帮您盘活资金、释放空间，更赋能您建立高效的资产循环体系。</p>
                        </div>
                        <!-- 行动号召区块 -->
                        <div class="content-block call-to-action">
                            <p>立即体验脱手网，开启“先管理，后流通”的科学盘活之路，让每一份滞纳资产都重获新生！</p>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    data() {

        return {
            tableHeight: '',
            tableData: [],
            form: {
                name: '',
            }

        }
    },
    props: [],

    updated() {

    },


    mounted() {

    },

    activated() {

    },
    created() {
        this.tableHeight_fun()
    },
    watch: {

    },
    methods: {
        tableHeight_fun() {
            this.$nextTick(() => {
                this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100
                console.log(this.tableHeight, 12122)
            })
        },
    }
}
</script>
<style lang="less" scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Microsoft YaHei", Arial, sans-serif;
}

body {
    background-color: #f5f7fa;
    color: #333;
    line-height: 1.6;
    padding: 40px 0;
}

/* 容器样式：居中显示，控制宽度 */
.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

/* 标题样式：突出主题，居中 */
.header-title {
    font-size: 28px;
    font-weight: 700;
    color: #000;
    text-align: center;
    margin-bottom: 20px;
    line-height: 1.4;
}

/* 内容区块样式：白色背景，圆角阴影，内边距 */
.content-block {
    background-color: #fff;
    //border-radius: 8px;
    //box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    padding: 30px 30px;
    margin-bottom: 0px;
    line-height: 1.8;
}

/* 段落样式：间距控制，字体大小 */
.content-block p {
    font-size: 16px;
    margin-bottom: 20px;
    text-align: justify;
}

/* 重点内容高亮：蓝色字体，加粗 */
.highlight {
    color: #000;
    font-weight: 600;
}

/* 行动号召区块：背景色突出，居中对齐 */
.call-to-action {
    background-color: #f0f5ff;
    border-left: 4px solid #000;
    padding: 25px 30px;
    border-radius: 0 8px 8px 0;
    text-align: center;
}

/* 行动号召文字：加粗，字体放大 */
.call-to-action p {
    font-size: 18px;
    font-weight: 600;
    color: #000;
    margin-bottom: 0;
}

/* 响应式适配：小屏幕调整内边距和字体 */
@media (max-width: 768px) {
    .header-title {
        font-size: 24px;
        margin-bottom: 30px;
    }

    .content-block {
        padding: 20px 25px;
    }

    .content-block p {
        font-size: 15px;
    }

    .call-to-action p {
        font-size: 16px;
    }
}
</style>